import { LOGIN_METHOD, type LoginMethodValue } from '@constants'
import { getXPlatformTokenDecoded, isUserLoggedInFn } from '@cosign-services/utils/getXPlatformToken'
import { getParsedStorageItem, getStorageItem, setStorageItem, STORAGE_EVENT } from '@utils/storageHelper'
import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { processEvent } from '../core/processEvent'
import { type RegisterCosignEventsArgs } from './registerCosignEvents'
import { getCountryCode } from './utils'

export const HAS_SENT_LOGIN_EVENT_STORAGE_KEY = 'hasSentLoginEvent'
export const LOGIN_OR_SIGNUP_METHOD_STORAGE_KEY = 'loginOrSignUpMethod'

export const resetSentLoginEvent = () => {
  setStorageItem(HAS_SENT_LOGIN_EVENT_STORAGE_KEY, false, STORAGE_EVENT.localStorage)
  setStorageItem(LOGIN_OR_SIGNUP_METHOD_STORAGE_KEY, null, STORAGE_EVENT.localStorage)
}
export const setLoginOrSignUpMethod = (method: LoginMethodValue) => {
  setStorageItem(LOGIN_OR_SIGNUP_METHOD_STORAGE_KEY, method, STORAGE_EVENT.localStorage)
}
export const clearLoginOrSignUpMethod = () => {
  setStorageItem(LOGIN_OR_SIGNUP_METHOD_STORAGE_KEY, null, STORAGE_EVENT.localStorage)
}
export const getLoginOrSignUpMethod = (): LoginMethodValue | null => {
  const value = getParsedStorageItem<LoginMethodValue>(LOGIN_OR_SIGNUP_METHOD_STORAGE_KEY, STORAGE_EVENT.localStorage) ?? null
  if (value === null) return null
  const validValues: string[] = Object.values(LOGIN_METHOD)
  return validValues.includes(value) ? value : null
}

export const sendLoginEvent = (args: RegisterCosignEventsArgs = {}) => {
  const xPlatformInfo = getXPlatformTokenDecoded()
  const isUserLoggedIn = isUserLoggedInFn(xPlatformInfo)
  const hasSentLoginEvent = getStorageItem(HAS_SENT_LOGIN_EVENT_STORAGE_KEY, STORAGE_EVENT.localStorage) === 'true'
  const loginOrSignUpMethod = getLoginOrSignUpMethod()
  // session 恢復不應視為登入動作
  if (isUserLoggedIn && !hasSentLoginEvent && loginOrSignUpMethod && xPlatformInfo?.platformUid) {
    const { platforms, conversionMap } = args
    processEvent({
      event: {
        eventName: 'login',
        eventParams: {
          method: loginOrSignUpMethod,
        },
      },
      platforms,
    })

    const countryCode = getCountryCode(window.location.pathname)
    const conversionLabel = countryCode ? conversionMap?.[countryCode]?.['login'] : undefined
    if (conversionLabel) {
      processEvent({
        event: {
          eventName: 'conversion',
          eventParams: {
            send_to: conversionLabel,
          },
        },
        platforms: [AnalyticsPlatforms.GA4],
      })
    }
    setStorageItem(HAS_SENT_LOGIN_EVENT_STORAGE_KEY, true, STORAGE_EVENT.localStorage)
  }
}
